export const ufGestorEstadualPrefix = 'UF_GESTOR_ESTADUAL_';

export const Role = {
  admin: 'ADMIN',
  judgingPanel: 'BANCA',
  externalAgency: 'FORNECEDOR',
  stateManager: 'GESTOR_ESTADUAL',
  evaluator: 'AVALIADOR',
} as const;

export const RoleLabel = {
  [Role.admin]: 'Administrador',
  [Role.judgingPanel]: 'Banca Avaliadora',
  [Role.externalAgency]: 'Fornecedor',
  [Role.stateManager]: 'Gestor Estadual',
  [Role.evaluator]: 'Avaliador',
} as const;

export type RoleKey = keyof typeof Role;

export type RoleModel = (typeof Role)[RoleKey];

export function roleLabel(role?: RoleModel) {
  return role ? RoleLabel[role] : '';
}
